import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

function StreamPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const flowType =
    localStorage.getItem("flow_type") || "mcq";

  const [streams, setStreams] = useState([]);
  const [activeStream, setActiveStream] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const tabRefs = useRef([]);

  useEffect(() => {
    const navbar = document.querySelector(".navbar");

    const handleScroll = () => {
      const currentScroll = window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      } else {
        navbar.style.transform = "translateX(-50%) translateY(-130%)";
        navbar.style.opacity = "0";
      }
    };

    if (navbar) {
      navbar.style.position = "fixed";
      navbar.style.top = "15px";
      navbar.style.left = "50%";
      navbar.style.width = "90%";
      navbar.style.maxWidth = "1100px";
      navbar.style.transform = "translateX(-50%)";
      navbar.style.zIndex = "9999";
      navbar.style.transition = "all 0.35s ease";
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);

      if (navbar) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }
    };
  }, []);

  useEffect(() => {
    loadStreams();
  }, [id]);

  useEffect(() => {
    if (activeStream) {
      loadSubjects(activeStream);
    }
  }, [activeStream]);

  useEffect(() => {
    const index = streams.findIndex(
      (item) => item.stream_name === activeStream
    );

    if (tabRefs.current[index]) {
      tabRefs.current[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeStream, streams]);

  const loadStreams = async () => {
    try {
      const res = await axios.get(
        `https://edunet.kmechengineering.com/root-engine1/api/streams-by-grade?grade_id=${id}`
      );

      const list = res.data.stream_data || [];
      setStreams(list);

      if (list.length > 0) {
        setActiveStream(list[0].stream_name);
      }
    } catch {
      setStreams([]);
    } finally {
      setLoading(false);
    }
  };

  const loadSubjects = async (stream) => {
    try {
      const res = await axios.get(
        `https://edunet.kmechengineering.com/root-engine1/api/subjects-by-stream?grade_id=${id}&stream_name=${encodeURIComponent(
          stream
        )}`
      );

      setSubjects(res.data.subject_data || []);
    } catch {
      setSubjects([]);
    }
  };

  const nextTab = () => {
    const current = streams.findIndex(
      (item) => item.stream_name === activeStream
    );

    if (current < streams.length - 1) {
      setActiveStream(streams[current + 1].stream_name);
    }
  };

  const prevTab = () => {
    const current = streams.findIndex(
      (item) => item.stream_name === activeStream
    );

    if (current > 0) {
      setActiveStream(streams[current - 1].stream_name);
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextTab,
    onSwipedRight: prevTab,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  return (
    <div className="mcq-page" {...handlers}>
      <h2 style={titleStyle}>Select Stream</h2>

      {loading && <p style={loadingText}>Loading...</p>}

      {!loading && (
        <>
          <div className="tab-main-wrap">
            {streams.map((item, index) => {
              const active =
                activeStream === item.stream_name;

              return (
                <button
                  key={item.stream_name}
                  ref={(el) =>
                    (tabRefs.current[index] = el)
                  }
                  onClick={() =>
                    setActiveStream(item.stream_name)
                  }
                  className={`tab-pill ${
                    active ? "active-tab" : ""
                  }`}
                >
                  {item.stream_name}
                </button>
              );
            })}
          </div>

          <div key={activeStream} style={subjectWrap}>
            <div className="subject-grid">
              {subjects.map((subject) => (
                <div
                  key={subject.subject_id}
                  className="stream-card"
                  onClick={() => {

                     localStorage.setItem(
                       "selected_stream",
                       activeStream
                     );

                     navigate(
                       `/${flowType}/subject/${subject.subject_id}?grade_id=${id}`,
                       {
                         state: {
                           type: flowType
                         }
                       }
                     );
                   }}
                >
                  <div style={circle}>S</div>

                  <div style={{ flex: 1 }}>
                    <h3 style={cardTitle}>
                      {subject.name}
                    </h3>

                    <p style={cardSub}>
                      Start MCQ
                    </p>

                    <span style={cardLink}>
                      Explore →
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      <style>
        {`
        @keyframes slideFade{
          0%{
            opacity:0;
            transform:translateX(35px);
          }
          100%{
            opacity:1;
            transform:translateX(0);
          }
        }

        @keyframes glassPop{
          0%{
            opacity:0.6;
            transform:scale(0.92);
          }
          100%{
            opacity:1;
            transform:scale(1);
          }
        }

        ::-webkit-scrollbar{
          display:none;
        }

        .tab-main-wrap{
          display:flex;
          gap:14px;
          overflow-x:auto;
          padding:10px 0 18px;
          margin-bottom:28px;
        }

        .tab-pill{
          border:none;
          cursor:pointer;
          flex-shrink:0;
          min-width:145px;
          height:58px;
          border-radius:999px;
          background:transparent;
          color:rgba(255,255,255,0.70);
          font-size:20px;
          font-weight:600;
          white-space:nowrap;
          transition:0.30s ease;
        }

        .tab-pill.active-tab{
          position:relative;
          color:#ffffff;
          background:
            linear-gradient(
              135deg,
              rgba(255,255,255,0.22),
              rgba(255,255,255,0.08)
            );
          backdrop-filter:blur(18px);
          -webkit-backdrop-filter:blur(18px);
          border:1px solid rgba(255,255,255,0.18);
          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.35),
            inset 0 -1px 0 rgba(255,255,255,0.06),
            0 8px 24px rgba(255,255,255,0.08);
          animation:glassPop 0.35s ease;
        }

        .subject-grid{
          display:flex;
          gap:22px;
          overflow-x:auto;
          padding-bottom:10px;
        }

        .stream-card{
          width:250px;
          min-width:250px;
          height:250px;
          border-radius:28px;
          padding:24px;
          cursor:pointer;
          flex-shrink:0;
          background:
            linear-gradient(145deg,#04041d,#090932);
          border:
            1px solid rgba(255,255,255,0.05);
          box-shadow:
            0 14px 35px rgba(0,0,0,0.45);
          display:flex;
          flex-direction:column;
          justify-content:flex-start;
          overflow:hidden;
          transition:0.3s ease;
        }

        .stream-card:hover{
          transform:translateY(-6px);
        }

        @media(max-width:768px){

          .mcq-page{
            padding:18px !important;
          }

          .tab-main-wrap{
            gap:10px;
            padding:8px 0 16px;
          }

          .tab-pill{
            min-width:120px;
            height:50px;
            font-size:17px;
          }

          .subject-grid{
            display:flex;
            flex-direction:column;
            gap:16px;
            overflow:visible;
          }

          .stream-card{
            width:100%;
            min-width:100%;
            height:auto;
            min-height:120px;
            border-radius:24px;
            padding:18px;
            flex-direction:row;
            align-items:center;
            gap:18px;
          }

        }
      `}
      </style>
    </div>
  );
}

export default StreamPage;

const titleStyle = {
  color: "#fff",
  fontSize: "42px",
  fontWeight: "800",
  textAlign: "center",
  marginBottom: "30px",
};

const loadingText = {
  color: "#fff",
};

const subjectWrap = {
  animation: "slideFade 0.4s ease",
};

const circle = {
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  flexShrink: 0,
  background:
    "linear-gradient(135deg,#7c3aed,#c026ff)",
  color: "#fff",
  fontSize: "28px",
  fontWeight: "800",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "18px",
};

const cardTitle = {
  color: "#fff",
  fontSize: "22px",
  fontWeight: "700",
  lineHeight: "1.3",
  marginBottom: "10px",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const cardSub = {
  color: "#c7c7dd",
  fontSize: "15px",
  marginBottom: "10px",
};

const cardLink = {
  color: "#9f67ff",
  fontSize: "17px",
  fontWeight: "700",
};